import uuid from 'uuid';
import { errorToast } from 'react-scale/corp/views/CorpProjectGroupManager/communication/Toast/errorToast';
import { getLogger } from '@scale/frontend-lib/datadog';

const logger = getLogger();

export function handleGenericError(error: any, userMessage: string) {
  const serverMessage = error.serverMessage ?? error.response?.message;
  const clientMessage = error.clientMessage ?? error.toString();

  const logId = uuid.v4();
  logger.error('Compass error', {
    logId,
    userMessage,
    serverMessage,
    clientMessage,
    error,
  });

  errorToast(logId, 'query', userMessage, serverMessage, clientMessage, error?.status, error?.url);
}
